import React from 'react';
import { useMrepState } from '../../helpers/mrepHelper';
import { truncateEthereumAddress } from '../../utils';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import Icons from '../icons/Icons';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import UserNavbar from './UserNavbar';
import './UserNavigator.scss';
import UserNavigatorSkeleton from './UserNavigatorSkeleton';

const UserNavigator = () => {
  const [{ userData }] = useMrepState();
  const copyAddress = () => {
    alert.info('Address copied', { autoClose: 200 });
    window.navigator.clipboard.writeText(userData?.address);
  };

  function redirectHumanEd() {
    window.open('https://mercle.ai/humaned', '_blank');
  }
  return (
    <FlexboxColumn gap='3rem' className='usernavigator_wrapper'>
      {userData ? (
        <FlexboxColumn gap='1.25rem' fw>
          <Flexbox justifyContent='space-between' className='usernavigator_wrapper__content' fw>
            <Flexbox gap='1rem' className='usernavigator_wrapper__content'>
              <img src={userData?.avatarUrl} className='usernavigator_wrapper__userImage' alt='user' />
              <FlexboxColumn alignItems={'flex-start'} gap='1rem' justifyContent={'space-between'}>
                <div>
                  <ThemedText.H3 weight={'medium'}>{userData?.name}</ThemedText.H3>
                  <Flexbox justifyContent='flex-start' gap='0.5rem'>
                    <ThemedText.H5 className='usernavigator_wrapper__details'>@{userData?.userName || truncateEthereumAddress(userData?.address)}</ThemedText.H5>
                    <div onClick={copyAddress}>
                      <Icons icon={'copy'} size={'1rem'} color={'#888'} />
                    </div>
                  </Flexbox>
                </div>
                <Flexbox gap='0.15rem'>
                  <ThemeLogo icon={'calendar'} />
                  <ThemedText.H5 className='usernavigator_wrapper__details'>Last data synced 03 April 2025 12:35:10 UTC</ThemedText.H5>
                </Flexbox>
              </FlexboxColumn>
            </Flexbox>
            <ThemeLogo onClick={redirectHumanEd} className={'pointer'} icon={'humanEdSoon'} />
            {/* <UserGrade /> */}
          </Flexbox>
        </FlexboxColumn>
      ) : (
        <UserNavigatorSkeleton />
      )}

      <UserNavbar />
    </FlexboxColumn>
  );
};

export default UserNavigator;
